















































































import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';

@Component({
  components: {
    LabelSlot,
  },
})
export default class CompetenceEvaluationPoints extends Vue {
  @Prop({ type: [String, Number], required: true })
  capacityScore!: string | number;

  @Prop({ type: [String, Number], required: true })
  resultScore!: string | number;

  @Prop({ type: Boolean, default: false })
  loading!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly!: boolean;

  @Prop({ type: String, default: 'Capacidade' })
  capacityAxisLabel!: string;

  @Prop({ type: Number, default: 0 })
  capacityMinValue!: number;

  @Prop({ type: Number, default: 10 })
  capacityMaxValue!: number;

  @Prop({ type: String, default: 'Resultado' })
  resultAxisLabel!: string;

  @Prop({ type: Number, default: 0 })
  resultMinValue!: number;

  @Prop({ type: Number, default: 10 })
  resultMaxValue!: number;

  rules: Rules = new Rules();

  get capacityLabel(): string {
    return `${this.capacityAxisLabel} (${this.capacityMinValue} a ${this.capacityMaxValue})`;
  }

  get resultLabel(): string {
    return `${this.resultAxisLabel} (${this.resultMinValue} a ${this.resultMaxValue})`;
  }

  updateCapacityScore(capacityScore: string) {
    this.$emit('update:capacityScore', capacityScore);
  }

  updateResultScore(resultScore: string) {
    this.$emit('update:resultScore', resultScore);
  }

  validateAndSave() {
    const { form }: any = this.$refs;
    if (!form.validate()) return;
    this.$emit('save');
  }
}
